var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4703_27107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1885 35.3685L4.66797 22.8125V43.4926C4.66797 44.3157 5.27714 45.013 6.1008 45.1293C20.4428 47.1529 35.191 47.205 49.9027 45.1293C50.723 45.0131 51.3346 44.3157 51.3346 43.4926V22.8092L34.8116 35.3685C30.9815 38.2804 24.9999 38.2709 21.1885 35.3685ZM49.9027 10.8634C35.4431 8.82319 20.5601 8.82319 6.10047 10.8634C5.2768 10.9796 4.66797 11.677 4.66797 12.5001V14.8632C4.66797 15.4378 5.25439 16.3933 6.50755 17.6023L24.2291 31.0749C26.2376 32.6019 29.7631 32.6019 31.7684 31.0749L49.5055 17.5958C50.749 16.3932 51.3346 15.441 51.3346 14.8665V12.5001C51.3346 11.677 50.7231 10.9796 49.9027 10.8634Z",
    fill: "#5D1CD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4703_27107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.5d3bd0dff8b114ad2948872dac127a64.svg";
export { ForwardRef as ReactComponent };